(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* One-shot flag that survives a FULL page navigation (unlike JS variables,
     which are destroyed and recreated on a normal forward navigation).
     Set the instant a mega menu link is activated, read on the very next
     page load, then discarded. This is what actually closes the menu on
     the destination page, regardless of cursor position or hover timing. */
  var SUPPRESS_KEY = 'fhHeaderSuppressHover';

  function readAndClearSuppressFlag() {
    try {
      var value = sessionStorage.getItem(SUPPRESS_KEY);
      if (value) sessionStorage.removeItem(SUPPRESS_KEY);
      return !!value;
    } catch (e) {
      return false;
    }
  }

  function setSuppressFlag() {
    try {
      sessionStorage.setItem(SUPPRESS_KEY, '1');
    } catch (e) {}
  }

  /* Runs in the CAPTURE phase, on document, for pointerdown AND click, so it
     fires before any bubbling handler and before the browser starts
     following the link. Closes the mega menu synchronously and marks the
     upcoming navigation so the destination page loads already closed. */
  function armCaptureCloseOnMegaMenuLinks(closeEverything) {
    function handler(event) {
      var link = event.target.closest(
        '.header-custom__megamenu a, .header-custom__mobile-sublink'
      );
      if (!link) return;
      closeEverything();
      setSuppressFlag();
    }
    document.addEventListener('pointerdown', handler, true);
    document.addEventListener('click', handler, true);
  }

  ready(function () {
    var header = document.querySelector('[data-header-custom]');
    if (!header) return;
    var overlay = document.querySelector('[data-header-overlay]');

    var panels = {};
    header.querySelectorAll('[data-menu-panel]').forEach(function (panel) {
      panels[panel.getAttribute('data-menu-panel')] = panel;
    });

    var closeTimeout = null;
    var activeKey = null;

    /* Suppressed until a real subsequent interaction happens on THIS page.
       Starts true whenever this load followed a mega menu link click
       (flag read below) so hover cannot reopen anything from residual
       cursor position on the very first frame. */
    var suppressHoverOpen = readAndClearSuppressFlag();

    /* Secondary guard, independent of navigation: only trust hover once the
       cursor has genuinely moved (coordinate change) or genuinely left an
       element, so a synthetic post-paint mouseenter can't open anything
       either. Kept because it also guards page loads that were NOT the
       result of a mega menu click (e.g. typing the URL directly). */
    var pointerArmed = false;
    var lastX = null;
    var lastY = null;

    function markRealInteraction() {
      pointerArmed = true;
      suppressHoverOpen = false;
    }

    document.addEventListener('mousemove', function (event) {
      if (pointerArmed) return;
      if (lastX === null) {
        lastX = event.clientX;
        lastY = event.clientY;
        return;
      }
      if (event.clientX !== lastX || event.clientY !== lastY) {
        markRealInteraction();
      }
    });

    function openPanel(key) {
      if (!panels[key] || activeKey === key) return;
      clearTimeout(closeTimeout);
      if (activeKey) closePanel();
      var panel = panels[key];
      var trigger = header.querySelector('[data-menu-trigger="' + key + '"]');
      panel.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      header.classList.add('has-open-menu');
      if (overlay) overlay.classList.add('is-visible');
      activeKey = key;
    }

    function closePanel() {
      if (!activeKey) return;
      var panel = panels[activeKey];
      var trigger = header.querySelector('[data-menu-trigger="' + activeKey + '"]');
      if (panel) panel.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      header.classList.remove('has-open-menu');
      if (overlay) overlay.classList.remove('is-visible');
      activeKey = null;
    }

    function scheduleClose() {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(closePanel, 150);
    }

    /* Synchronously clears every state class/attribute this header or its
       mega menus can carry. Only touches classes/attributes this script
       itself sets. */
    function resetHeaderState() {
      clearTimeout(closeTimeout);
      closePanel();
      header.classList.remove('is-hovering', 'has-open-menu', 'mobile-menu-open');
      if (overlay) overlay.classList.remove('is-visible');
      header.querySelectorAll('[data-menu-trigger]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      var mobileMenuEl = document.querySelector('[data-mobile-menu]');
      var mobileToggleEl = header.querySelector('[data-mobile-menu-toggle]');
      if (mobileMenuEl) mobileMenuEl.classList.remove('is-open');
      if (mobileToggleEl) mobileToggleEl.setAttribute('aria-expanded', 'false');
    }

    /* Capture-phase close, BEFORE navigation starts. */
    armCaptureCloseOnMegaMenuLinks(resetHeaderState);

    header.querySelectorAll('[data-menu-trigger]').forEach(function (trigger) {
      var key = trigger.getAttribute('data-menu-trigger');

      trigger.addEventListener('mouseenter', function () {
        if (!pointerArmed || suppressHoverOpen) return;
        clearTimeout(closeTimeout);
        openPanel(key);
      });

      trigger.addEventListener('mouseleave', function () {
        markRealInteraction();
      });

      trigger.addEventListener('focus', function () {
        if (suppressHoverOpen) return;
        openPanel(key);
      });
    });

    Object.keys(panels).forEach(function (key) {
      panels[key].addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
      });
    });

    header.addEventListener('mouseenter', function () {
      if (!pointerArmed || suppressHoverOpen) return;
      clearTimeout(closeTimeout);
      header.classList.add('is-hovering');
    });

    header.addEventListener('mouseleave', function () {
      markRealInteraction();
      header.classList.remove('is-hovering');
      scheduleClose();
    });

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanel();
      }
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        resetHeaderState();
      });
    }

    /* Scroll state: solo posicion (fixed una vez pasado el hero). El scroll ya NO pinta el header:
       nunca se agrega 'is-solid', asi el fondo sigue transparente en cualquier posicion. El color solo
       aparece con el cursor dentro del header ('is-hovering' / :hover) o con un mega menu abierto. */
    var scrollThreshold = 80;
    function updateScrollState() {
      header.classList.remove('is-solid');
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-fixed');
      } else {
        header.classList.remove('is-fixed');
      }
    }
    window.addEventListener('scroll', updateScrollState, { passive: true });
    updateScrollState();

    /* Mobile menu */
    var mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = mobileMenu.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        header.classList.toggle('mobile-menu-open', isOpen);
        if (overlay) overlay.classList.toggle('is-visible', isOpen);
      });

      mobileMenu.querySelectorAll('[data-mobile-expand]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-mobile-expand');
          var submenu = mobileMenu.querySelector('[data-mobile-submenu="' + key + '"]');
          if (!submenu) return;
          var isOpen = submenu.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }

    /* Force-closed state on this load if we just came from a mega menu
       link, or as general hygiene either way. */
    resetHeaderState();

    /* pageshow covers the back/forward-cache (bfcache) restore case, where
       the browser can reuse a previous render of the DOM (and, in some
       engines, JS state) instead of doing a fresh load. event.persisted is
       true specifically for a bfcache restore. */
    window.addEventListener('pageshow', function (event) {
      resetHeaderState();
      pointerArmed = false;
      lastX = null;
      lastY = null;
      if (event.persisted) {
        suppressHoverOpen = readAndClearSuppressFlag();
      }
    });
  });
})();
